<template>
  <article class="lora-info-teaser">
    <div class="lora-info-teaser__cover">
      <ResponsiveImage v-if="image" :image="image" />
    </div>
    <h2 class="lora-info-teaser__heading">
      LoRa Info<br>
      {{ title }}
    </h2>
    <p class="lora-info-teaser__file-meta">
      {{ useFormatFileMetaData(file.fieldMediaFile?.entity?.filesize, file.fieldMediaFile?.entity?.filemime) }}
    </p>
    <IconLink class="lora-info-teaser__download" label="Download" :url="useFileUrl(file.url.path)"
      icon="CircleDownloadFilled" />
  </article>
</template>

<script setup lang="ts">

import { type MediaImageFragment, type MediaFileFragment } from '#graphql-operations'

const props = defineProps<{
  title: string,
  file: MediaFileFragment,
  image: MediaImageFragment,
}>()

</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.lora-info-teaser {
  &__inner {
    text-decoration: none;
  }

  &__cover {
    aspect-ratio: 1 / 1;

    :deep(.responsive-image) {
      height: 100%;

      img,
      picture {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  &__heading {
    margin-top: var(--space--sm);
    margin-bottom: 0;
  }

  &__file-meta {
    @include tools.typo-small;
  }

  &__download {
    margin-top: var(--space--m);
  }
}
</style>
